module.exports = __webpack_public_path__ + "img/land-rover.4ea2b973.png";